import * as moment from 'jalali-moment';
import { Injectable } from '@angular/core';

@Injectable()
export class DateHelper {
  private PersianMonthNames = new Map<string, string>();

  constructor() {
    this.PersianMonthNames.set('01', 'فروردين')
      .set('02', 'ارديبهشت')
      .set('03', 'خرداد')
      .set('04', 'تير')
      .set('05', 'مرداد')
      .set('06', 'شهريور')
      .set('07', 'مهر')
      .set('08', 'آبان')
      .set('09', 'آذر')
      .set('10', 'دي')
      .set('11', 'بهمن')
      .set('12', 'اسفند');
  }

  getPersianMonthNameByMonthNumber(month: string) {
    return this.PersianMonthNames.get(month);
  }

  getPersianMonthName(date: Date) {
    return this.PersianMonthNames.get(moment(date).format('jMM'));
  }

  getPersianMonthMaximumDay(month: string, year: string): number {
    switch (month) {
      case '01':
        return 31;
      case '02':
        return 31;
      case '03':
        return 31;
      case '04':
        return 31;
      case '05':
        return 31;
      case '06':
        return 31;
      case '07':
        return 30;
      case '08':
        return 30;
      case '09':
        return 30;
      case '10':
        return 30;
      case '11':
        return 30;
      case '12': {
        const d = year + '/' + '12' + '/' + '30';
        const todayJalali = moment.from(d, 'fa', 'YYYY/MM/DD');
        if (todayJalali.isValid()) {
          return 30;
        }
        return 29;
      }
    }
  }

  getYearAndMonthPersian(date: Date): string {
    return (
      this.PersianMonthNames.get(moment(date).format('jMM')) +
      ' ' +
      moment(date).format('jYYYY')
    );
  }

  getMonthAndDayPersian(date: Date): string {
    return (
      moment(date).format('jDD') +
      ' ' +
      this.PersianMonthNames.get(moment(date).format('jMM'))
    );
  }

  getYearAndMonthAndDayPersian(date: Date): string {
    return (
      moment(date).format('jDD') +
      ' ' +
      this.PersianMonthNames.get(moment(date).format('jMM')) +
      ' ' +
      moment(date).format('jYYYY')
    );
  }
  pickerGetYearAndMonthAndDayPersian(date: Date): string {
    return (
      moment(date).format('jDD') +
      ' ' +
      this.PersianMonthNames.get(moment(date).format('jMM')) +
      ' ' +
      moment(date).format('jYYYY')
    );
  }

  isSameDay(date1: Date, date2: Date) {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }

  getPersianBirthdayFormat(date: Date): string {
    return (
      moment(date).format('jYYYY') +
      '/' +
      moment(date).format('jMM') +
      '/' +
      moment(date).format('jDD')
    );
  }

  getMonthAndDayPersianForTwoDates(date1: Date, date2: Date): string {
    if (
      this.PersianMonthNames.get(moment(date1).format('jMM')) !==
      this.PersianMonthNames.get(moment(date2).format('jMM'))
    ) {
      return (
        this.getMonthAndDayPersian(date1) +
        ' - ' +
        this.getMonthAndDayPersian(date2)
      );
    } else {
      return (
        moment(date1).format('jDD') + ' - ' + this.getMonthAndDayPersian(date2)
      );
    }
  }

  getTodayYesterdayTomorrowOrMonthAndDay(date: Date): string {
    let label = '';
    if (this.isSameDay(date, new Date())) {
      label = 'امروز';
    } else if (
      this.isSameDay(
        date,
        new Date(new Date().setDate(new Date().getDate() - 1))
      )
    ) {
      label = 'دیروز';
    } else if (
      this.isSameDay(
        date,
        new Date(new Date().setDate(new Date().getDate() + 1))
      )
    ) {
      label = 'فردا';
    } else {
      label = this.getMonthAndDayPersian(date);
    }
    return label;
  }

  getPostTimeLabel(createdAt: string): string {
    let res = '';
    const date = new Date(createdAt);
    if (new Date().getTime() - date.getTime() < 60 * 1000) {
      res = 'به‌تازگی';
    } else if (new Date().getTime() - date.getTime() < 60 * 60 * 1000) {
      const n = (new Date().getTime() - date.getTime()) / (60 * 1000);
      res = Math.floor(n) + ' دقیقه پیش';
    } else if (new Date().getTime() - date.getTime() < 24 * 60 * 60 * 1000) {
      const n = (new Date().getTime() - date.getTime()) / (60 * 60 * 1000);
      res = Math.floor(n) + ' ساعت پیش';
    } else if (
      new Date().getTime() - date.getTime() <
      7 * 24 * 60 * 60 * 1000
    ) {
      const n =
        new Date().getDay() - date.getDay() > 0
          ? new Date().getDay() - date.getDay()
          : new Date().getDay() - date.getDay() + 7;
      res = Math.floor(n) + ' روز پیش';
    } else if (
      new Date().getTime() - date.getTime() <
      365 * 24 * 60 * 60 * 1000
    ) {
      res =
        moment(date).format('jDD') +
        ' ' +
        this.PersianMonthNames.get(moment(date).format('jMM'));
    } else {
      const n =
        (new Date().getTime() - date.getTime()) / (365 * 24 * 60 * 60 * 1000);
      res = Math.floor(n) + ' سال پیش';
    }
    // console.log('post' , date, res)
    return res;
  }

  calculateDays(startDate: number, currentDate: number): number {
    const diffTime = Math.abs(currentDate - startDate);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  }
}
